﻿const debounce = (func, wait, immediate) => {
	var timeout;
	return () => {
		var context = this, args = arguments;

		var later = () => {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);

		if (callNow) func.apply(context, args);
	};
};

export const pushToDataLayer = (object, debounceTime) => {
	window.dataLayer = window.dataLayer ? window.dataLayer : [];

	if (debounceTime) {
		debounce(function () {
			window.dataLayer.push(object);
			//console.log('dataLayer', object);
			//console.table(window.dataLayer);
		}, debounceTime);
	} else {
		window.dataLayer.push(object);

		//console.log('dataLayer', object);
		//console.table(window.dataLayer);
	}
}
